module.exports = __webpack_public_path__ + "static/media/epipen-paywall-header-logo.b6caa888.png";